import { render, staticRenderFns } from "./HazmatCodeList.vue?vue&type=template&id=216ac7a2&scoped=true&"
import script from "./HazmatCodeList.vue?vue&type=script&lang=js&"
export * from "./HazmatCodeList.vue?vue&type=script&lang=js&"
import style0 from "./HazmatCodeList.vue?vue&type=style&index=0&id=216ac7a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "216ac7a2",
  null
  
)

export default component.exports